import React, { useMemo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";

/**
 * NVR iframe `src` from `REACT_APP_NVR_DASHBOARD_IFRAME_URL` in `.env` only.
 * Restart the dev server after changing env (Create React App inlines at compile time).
 */
function getNvrDashboardIframeSrc(): string {
  const raw = process.env.REACT_APP_NVR_DASHBOARD_IFRAME_URL;
  return typeof raw === "string" ? raw.trim() : "";
}

/**
 * NVR Selection: external NVR dashboard shown inside the layout content area via iframe.
 */
export function NvrManagementPage() {
  const iframeSrc = useMemo(() => getNvrDashboardIframeSrc(), []);

  if (!iframeSrc) {
    return (
      <Box sx={{ p: 2, bgcolor: "#fff", minHeight: 200 }}>
        <Alert severity="warning">
          NVR dashboard URL is not configured. Set{" "}
          <Typography component="span" variant="body2" sx={{ fontFamily: "monospace" }}>
            REACT_APP_NVR_DASHBOARD_IFRAME_URL
          </Typography>{" "}
          in your <Typography component="span" variant="body2" sx={{ fontFamily: "monospace" }}>.env</Typography>{" "}
          file and restart the dev server.
        </Alert>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        alignSelf: "stretch",
        width: "100%",
        minHeight: 0,
        bgcolor: "#fff",
        height: "calc(100vh - 100px)",
      }}
    >
      <iframe
        title="NVR dashboard"
        src={iframeSrc}
        style={{
          flex: 1,
          width: "100%",
          minHeight: 0,
          border: 0,
          display: "block",
          height: "100%",
        }}
        allow="fullscreen"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </Box>
  );
}

export default NvrManagementPage;
